module.exports = {
    RECEIVE_DECLARATION: 'RECEIVE_DECLARATION',
    RECEIVE_DECLARATION_CONTRIBUTORS: 'RECEIVE_DECLARATION_CONTRIBUTORS',
    RECEIVE_DECLARATIONS_STATS_EXPLOITATION: 'RECEIVE_DECLARATIONS_STATS_EXPLOITATION',
    RECEIVE_SURVEY: 'RECEIVE_SURVEY',
    RECEIVE_SURVEYS: 'RECEIVE_SURVEYS',
}
